(() => {
  const existing = window.SkyTroveProductStrip;
  if (existing) {
    existing.init(document);
    return;
  }

  const instances = new WeakMap();
  const sectionsWithin = (root) => {
    const sections = [];
    if (root instanceof Element && root.matches('[data-product-strip-section]')) sections.push(root);
    sections.push(...root.querySelectorAll('[data-product-strip-section]'));
    return sections;
  };

  const mount = (section) => {
    if (instances.has(section)) return;
    const viewport = section.querySelector('[data-product-strip]');
    const previous = section.querySelector('[data-product-strip-prev]');
    const next = section.querySelector('[data-product-strip-next]');
    if (!viewport || !previous || !next) return;

    const controller = new AbortController();
    const { signal } = controller;
    const update = () => {
      const overflow = viewport.scrollWidth > viewport.clientWidth + 2;
      section.toggleAttribute('data-strip-overflow', overflow);
      previous.disabled = !overflow || viewport.scrollLeft <= 1;
      next.disabled = !overflow || viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 1;
    };
    const move = (direction) => viewport.scrollBy({
      left: direction * Math.max(viewport.clientWidth * 0.8, 180),
      behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });

    previous.addEventListener('click', () => move(-1), { signal });
    next.addEventListener('click', () => move(1), { signal });
    viewport.addEventListener('scroll', update, { passive: true, signal });
    const resizeObserver = new ResizeObserver(update);
    resizeObserver.observe(viewport);
    instances.set(section, { controller, resizeObserver });
    section.dataset.stripReady = 'true';
    update();
  };

  const init = (root = document) => sectionsWithin(root).forEach(mount);
  const destroy = (root) => sectionsWithin(root).forEach((section) => {
    const instance = instances.get(section);
    instance?.controller.abort();
    instance?.resizeObserver.disconnect();
    instances.delete(section);
    delete section.dataset.stripReady;
  });

  window.SkyTroveProductStrip = { init, destroy };
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroy(event.target));
  init(document);
})();
